import type { KhoaDich } from '../../i18n';
import type { BienTheTrangThai } from './constants';
import type { CheDoGiaoTiep, ChatbotMode, KieuTruong, PermLevel } from './types';

/**
 * Hằng của nhóm màn Cấu hình chatbot và Phân quyền dữ liệu (ADR-0086).
 */

/**
 * Địa chỉ tệp script của khung nhúng: phục vụ TĨNH từ web-host (`/nhung/tro-ly-ai.js`, ADR-0086 mục 7), cùng tên miền
 * với cổng. Script tự lấy gốc API từ origin của chính nó.
 */
export function urlSdkNhung(): string {
  const goc = typeof window === 'undefined' ? '' : window.location.origin;
  return `${goc}/nhung/tro-ly-ai.js`;
}

/** Placeholder khoá API trong đoạn mã — người vận hành thay bằng khoá tạo ở màn Khoá API. */
export const CHO_KHOA_API = '<TENANT_API_KEY>';

/** Đoạn mã dán vào trang khách: khoá nhúng của bot và khoá API của tenant (quyền `tro-ly-ai:nhung:hoi`). */
export function doanMaNhung(khoa: string): string {
  return `<script src="${urlSdkNhung()}"
        data-key="${khoa}"
        data-api-key="${CHO_KHOA_API}" defer></script>`;
}

export const CHE_DO_TRA_LOI: { ma: ChatbotMode; nhan: KhoaDich; mo: KhoaDich }[] = [
  { ma: 'knowledge_only', nhan: 'troLyAiBot.modeKnowledgeOnly', mo: 'troLyAiBot.modeKnowledgeOnlyMo' },
  { ma: 'open', nhan: 'troLyAiBot.modeOpen', mo: 'troLyAiBot.modeOpenMo' },
];

export const NHAN_KENH: Record<CheDoGiaoTiep, { nhan: KhoaDich; mo: KhoaDich }> = {
  van_ban: { nhan: 'troLyAiBot.kenh.van_ban', mo: 'troLyAiBot.kenh.van_banMo' },
  giong_noi: { nhan: 'troLyAiBot.kenh.giong_noi', mo: 'troLyAiBot.kenh.giong_noiMo' },
  ca_hai: { nhan: 'troLyAiBot.kenh.ca_hai', mo: 'troLyAiBot.kenh.ca_haiMo' },
};

export const NHAN_KIEU_TRUONG: Record<KieuTruong, KhoaDich> = {
  van_ban: 'troLyAiBotKichBan.kieuVanBan',
  so: 'troLyAiBotKichBan.kieuSo',
  dien_thoai: 'troLyAiBotKichBan.kieuDienThoai',
  email: 'troLyAiBotKichBan.kieuEmail',
  ngay: 'troLyAiBotKichBan.kieuNgay',
};

/**
 * Mức quyền dữ liệu của một vai. `full` xanh: đọc mọi bảng. `tables` xanh nhấn: đọc một phần. `none` xám: chưa cấp — không
 * phải sự cố, chỉ là mặc định đóng, nên không tô đỏ.
 */
export const MUC_QUYEN: Record<PermLevel, { khoa: KhoaDich; nhan: KhoaDich; variant: BienTheTrangThai; cham: string }> = {
  full: { khoa: 'troLyAiBotQuyenDuLieu.mucFull', nhan: 'troLyAiBotQuyenDuLieu.nhanToanBo', variant: 'success', cham: 'bg-success-600' },
  tables: { khoa: 'troLyAiBotQuyenDuLieu.mucTables', nhan: 'troLyAiBotQuyenDuLieu.nhanBang', variant: 'primary', cham: 'bg-primary-600' },
  none: { khoa: 'troLyAiBotQuyenDuLieu.mucNone', nhan: 'troLyAiBotQuyenDuLieu.nhanDong', variant: 'neutral', cham: 'bg-dark-300' },
};

export const THU_TU_MUC_QUYEN: PermLevel[] = ['none', 'tables', 'full'];
